// extracted by mini-css-extract-plugin
module.exports = {"pointsDisclaimer":"PointsDisclaimer_pointsDisclaimer__aQJVf"};